export default {
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.loadItems();
        },
        onSearch(params) {
            this.updateParams({search: params.searchTerm});
            this.loadItems();
        },
        onSortChange(params) {
            this.updateParams({
                sort: [{
                    type: params[0].type,
                    field: params[0].field,
                }],
            });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.loadItems();
        },
    }
}

export const tableData = {
    isLoading: false,
    columns: [],
    rows: [],
    totalRecords: 0,
    serverParams: {
        search: null,
        columnFilters: {},
        sort: [
            {
                field: 'created_at',
                type: 'desc'
            }
        ],
        page: 1,
        perPage: 10
    }
}